<template>
  <pre-auth-view>
    <h2 class="mb-4">Forgot Password</h2>
    <form @submit.prevent="submit">
      <bdg-text-field ref="email" name="Email" v-model="email" required />
      <bdg-button
        class="w-full mt-8 uppercase"
        type="submit"
        :is-loading="isForgettingPassword"
      >
        Submit
      </bdg-button>
      <p
        class="message"
        :class="{ error: receivedErrorResponse }"
        v-if="responseMessage"
      >
        {{ responseMessage }}
      </p>
    </form>
    <router-link class="back-to-login-link" :to="{ name: 'login' }">
      Back to Login
    </router-link>
  </pre-auth-view>
</template>

<script>
import PreAuthView from "./PreAuthView";
import BdgTextField from "../../forms/fields/BdgTextField";
import BdgButton from "../../elements/BdgButton";
import { validateRequiredRefs } from "../../helpers";
import { ApiResponseStatus } from "../../constants/enums";

export default {
  name: "ForgotPassword",
  components: { BdgButton, BdgTextField, PreAuthView },
  data() {
    return {
      email: null,
      requiredRefs: ["email"],
      responseMessage: null,
      receivedErrorResponse: false
    };
  },
  computed: {
    isForgettingPassword() {
      return this.$store.state.Auth.isForgettingPassword;
    }
  },
  methods: {
    validate() {
      return validateRequiredRefs(this, true);
    },
    submit() {
      if (!this.validate()) {
        return;
      }

      this.$store.dispatch("forgotPassword", this.email).then(res => {
        this.responseMessage = res.message;
        this.receivedErrorResponse = res.status === ApiResponseStatus.ERROR;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.message {
  @apply mt-4 text-sm;

  &.error {
    @apply text-red;
  }
}

.back-to-login-link {
  @apply inline-block w-full mt-8 text-blue text-center underline;
}
</style>
